<ngx-loading [show]="loading" [config]="{backdropBorderRadius: '14px'}"></ngx-loading>

<div class="table-scroll mt-2">
  <div echarts class="demo-chart" *ngIf="roDetailsCount" [options]="RoChartOption" (chartClick)="chartClicked($event)">
  </div>
</div>
